// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PublishComponent_wrapper__3xedm","pubupButton":"PublishComponent_pubupButton__2nSnh"};